/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  "for": {
    type: String,
    "default": ""
  },
  help: {
    type: [String, Function]
  },
  label: {
    type: [String, Function],
    "default": ""
  },
  labelAlign: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "right", "top"].includes(val);
    }
  },
  labelWidth: {
    type: [String, Number]
  },
  name: {
    type: [String, Number]
  },
  requiredMark: {
    type: Boolean,
    "default": void 0
  },
  rules: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  showErrorMessage: {
    type: Boolean,
    "default": void 0
  },
  statusIcon: {
    type: [Boolean, Function],
    "default": void 0
  },
  successBorder: Boolean
};

export { props as default };
//# sourceMappingURL=form-item-props.js.map
